var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_99_2965)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_99_2965",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.370117 0H20.3701V20H0.370117V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_99_2965)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_99_2965",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.370117 0H20.3701V20H0.370117V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_99_2965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6334 18.7099H9.3001C8.97856 18.7104 8.66006 18.6476 8.36284 18.5249C8.06561 18.4022 7.7955 18.2221 7.56794 17.995C7.34038 17.7678 7.15985 17.498 7.03667 17.201C6.9135 16.904 6.8501 16.5856 6.8501 16.264V8.9307C6.8501 8.28202 7.10778 7.65991 7.56647 7.20123C8.02515 6.74255 8.64726 6.48486 9.29593 6.48486H16.6293C17.2779 6.48486 17.9 6.74255 18.3587 7.20123C18.8174 7.65991 19.0751 8.28202 19.0751 8.9307V16.264C19.0751 16.912 18.818 17.5335 18.3602 17.992C17.9024 18.4506 17.2814 18.7088 16.6334 18.7099ZM9.3001 8.11153C9.08395 8.11153 8.87665 8.1974 8.72381 8.35024C8.57096 8.50308 8.4851 8.71038 8.4851 8.92653V16.2599C8.4851 16.3669 8.50618 16.4729 8.54714 16.5718C8.58809 16.6706 8.64813 16.7605 8.72381 16.8362C8.79949 16.9118 8.88933 16.9719 8.98821 17.0128C9.08709 17.0538 9.19307 17.0749 9.3001 17.0749H16.6334C16.7405 17.0749 16.8464 17.0538 16.9453 17.0128C17.0442 16.9719 17.134 16.9118 17.2097 16.8362C17.2854 16.7605 17.3454 16.6706 17.3864 16.5718C17.4274 16.4729 17.4484 16.3669 17.4484 16.2599V8.92653C17.4484 8.71038 17.3626 8.50308 17.2097 8.35024C17.0569 8.1974 16.8496 8.11153 16.6334 8.11153H9.3001Z",
    fill: "#9196AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.92261 13.5215H4.10761C3.78642 13.5215 3.46837 13.4583 3.17163 13.3354C2.87489 13.2125 2.60526 13.0323 2.37814 12.8052C2.15103 12.5781 1.97087 12.3084 1.84795 12.0117C1.72504 11.715 1.66178 11.3969 1.66178 11.0757V3.74238C1.66134 3.42091 1.72428 3.1025 1.847 2.80538C1.96971 2.50825 2.1498 2.23823 2.37696 2.01076C2.60412 1.78329 2.8739 1.60283 3.17086 1.47971C3.46782 1.35659 3.78614 1.29321 4.10761 1.29321H11.4409C12.0896 1.29321 12.7117 1.5509 13.1704 2.00958C13.6291 2.46826 13.8868 3.09037 13.8868 3.73905V4.55405C13.8868 4.77031 13.8009 4.97771 13.6479 5.13063C13.495 5.28355 13.2876 5.36946 13.0714 5.36946C12.8551 5.36946 12.6477 5.28355 12.4948 5.13063C12.3419 4.97771 12.2559 4.77031 12.2559 4.55405V3.73905C12.2559 3.52289 12.1701 3.3156 12.0172 3.16275C11.8644 3.00991 11.6571 2.92405 11.4409 2.92405H4.10761C3.89146 2.92405 3.68416 3.00991 3.53132 3.16275C3.37848 3.3156 3.29261 3.52289 3.29261 3.73905V11.0724C3.29261 11.2885 3.37848 11.4958 3.53132 11.6487C3.68416 11.8015 3.89146 11.8874 4.10761 11.8874H4.92261C5.02969 11.8874 5.13572 11.9085 5.23466 11.9495C5.33359 11.9904 5.42348 12.0505 5.4992 12.1262C5.57491 12.2019 5.63498 12.2918 5.67596 12.3907C5.71693 12.4897 5.73803 12.5957 5.73803 12.7028C5.73803 12.8099 5.71693 12.9159 5.67596 13.0148C5.63498 13.1138 5.57491 13.2037 5.4992 13.2794C5.42348 13.3551 5.33359 13.4152 5.23466 13.4561C5.13572 13.4971 5.02969 13.5182 4.92261 13.5182V13.5215Z",
    fill: "#9196AF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_99_2965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.370117)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.14d0788bcf1d3ebd7727908e4938f1c0.svg";
export { ForwardRef as ReactComponent };